<script>
export default {
    name: "InvoiceDetailsPrint",

    data() {

        return {
            invoiceItems: [],
            patient: {},
        };
    },

    computed: {

        totalInsuranceAmt() {

            if(!this.invoiceItems.length) return 0;

            const filteredItems = this.invoiceItems.filter(invItem => invItem.insuranceAmountPaid);

            if(!filteredItems.length) return 0;

            const invItems = filteredItems.map(item => parseFloat(item.insuranceAmountPaid));

            return invItems.reduce((cost, accTotal) => cost + accTotal);
        },
    },

    mounted() {

        Promise.allSettled([ this.fetchPatient(), this.fetchInvoiceDetails(), ]).then(() => {
            window.print();
            window.onafterprint = function() { window.close(); };
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.query.patientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchInvoiceDetails() {

            return this.$http.get(`AccountsReports/GetInvoiceperVisitItems?VisitNo=${this.$route.query.visitNo}`).then(response => {
                this.invoiceItems = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center my-2">
            <h5 class="font-bold text-base uppercase">Patient Invoice</h5>
        </div>
        <div class="w-full flex flex-row">
            <div class="flex-1">
                <h5 class="font-medium">{{ patient.names }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">IP File No: {{ patient.ipfileno }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">OP File NO: {{ patient.opfileno }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">MRN: {{ patient.patienT_ID }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">Visit No: {{ patient.visitNo }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">Mode: {{ patient.pMode }}</h5>
            </div>
        </div>
        <table class="table">
            <thead class="text-sm">
                <tr>
                    <th class="p-tiny">#</th>
                    <th class="p-tiny">Bill No</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Description</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Cost</th>
                    <th class="p-tiny">Insurance Amt</th>
                </tr>
            </thead>
            <tfoot class="text-sm">
                  <tr>
                      <th colspan="6" class="p-tiny"></th>
                      <th class="p-tiny">Total</th>
                      <th class="p-tiny">{{ totalInsuranceAmt | numberFormat }}</th>
                  </tr>
            </tfoot>
            <tbody class="text-sm">
                <tr v-for="(invoiceItem, idx) in invoiceItems" :key="idx">
                    <td class="p-tiny">{{ invoiceItem.invoiceDetailID }}</td>
                    <td class="p-tiny">{{ invoiceItem.billNo }}</td>
                    <td class="p-tiny">{{ invoiceItem.item }}</td>
                    <td class="p-tiny">{{ invoiceItem.description }}</td>
                    <td class="p-tiny">{{ invoiceItem.userName }}</td>
                    <td class="p-tiny">{{ invoiceItem.qty }}</td>
                    <td class="p-tiny">{{ invoiceItem.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ invoiceItem.insuranceAmountPaid | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>